module.exports = __webpack_public_path__ + "static/avatar-801481ab7813575ff4395d20cd279a49.jpg";